var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{
        name: _vm.HOME_PAGE_NAME_GRID,
        params: { name: _vm.path },
        query: _vm.query,
    }}},[_c('button',{staticClass:"button__view-all",on:{"click":_vm.onClick}},[_c('div',{staticClass:"button__text"},[_vm._v("View All")]),_c('ViewAllArrowIcon',{staticClass:"button__icon"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }